import SurveyViewService from 'services/data-handler-services/survey-service';
import _ from 'lodash';
import Chaplin from 'chaplin';

const SurveyService = function () {
  this.triggerSurvey = function (blockView) {
    const url = SurveyViewService.surveyUrl(blockView.model.get('slug'), blockView.model.get('return_hash'));
    if (url === undefined) {
      console.warn('No Survey url');
    } else {
      setTimeout(
        _.bind(function () {
          Chaplin.mediator.publish('window:navigate', url);
        }, this),
        2000
      );
    }
  };

  this.userHasCompletedSurvey = function (courseSlug) {
    return !!SurveyViewService.getActivityProgressForSlug(courseSlug);
  };

  this.getSurvey = function (blockView) {
    return blockView.model.get('survey').fetch({
      error: function (err) {
        console.error('Error fetching survey: ', err);
      },
      success: function () {
        setSections(blockView.model);
        blockView.model.get('survey').initResponseSet({
          success: responseSet => {
            blockView.model.set('responseSet', responseSet);
            blockView.render();
          },
        });
      },
    });
  };

  this.saveSurveyResponse = function (blockView, dataset, options) {
    const responseSet = blockView.model.get('responseSet');
    if (options && options.multipleQuestion) {
      responseSet.answerQuestions(dataset);
    } else {
      responseSet.answerQuestion(dataset.questionId, dataset.answerId);
    }
    return responseSet.save();
  };
  this.refreshResponseSet = function () {};

  const setSections = function (model) {
    const survey = model.get('survey');
    const sections = survey.sections.models;
    sections.forEach(section => {
      section.questions = section.get('questions');
    });
    survey.set('sections', sections);
  };
};

export default new SurveyService();
